import React, { useEffect } from 'react';
import './invoice.scss';
import DynamicInputList from '../software-dynamic-version-7/list-input-v-7';
import moment from 'moment';
import securityService from '../security/security.service';
import invoiceService from './invoice.service';
import InvoiceAdd from './invoice-add';
import { QRCodeGenerator } from '@syncfusion/ej2-barcode-generator';
import { openReportsMenu, setMenuLoading ,closeReportsMenu} from './report-menu';

let details = [];

const InvoiceList = (props) => {
  useEffect(() => {
    details = [];
    return () => {
      closeReportsMenu()
    };
  }, []);

  const detailsUpdate = (e) => {
    details = e || [];
  };

  const columns = [
    // {  field: "Commands",headerText:'Commands',width:'370',textAlign:'center' ,headerTextAlign:'center',other:[
    //   {button:[
    //     {Id:'FBRInvoice',Content:'FBR Invoice', BgColor:'#2c842d' ,Color:'#f4f4f4',
    //       Input:{
    //       Route:'FBRInvoice' ,
    //       Title:'FBRInvoice',  
    //       Security:'Sale Invoice',
    //       Width:'150px'
    //     }}
    //   ]}
    // ]},
    { field: "MainInvoiceID", headerText: "ID", width: "110px", textAlign: "right", headerTextAlign: "center", other: [{}] },
    { field: "InvoiceID", headerText: "Invoice No", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{}] },
    { field: "InvoiceDate", headerText: "Invoice Date", width: "150px", textAlign: "left", headerTextAlign: "center", other: [{ format: "dd-MMM-yyyy" }] },
    { field: "buyerBusinessName", headerText: "Buyer Name", width: "170px", textAlign: "left", headerTextAlign: "center", other: [{}] },
    { field: "InvoiceReferenceNo", headerText: "Reference No", width: "170px", textAlign: "left", headerTextAlign: "center", other: [{}] },
    { field: "DueDate", headerText: "Due Date", width: "150px", textAlign: "left", headerTextAlign: "center", other: [{ format: "dd-MMM-yyyy" }] },
    { field: "Remarks", headerText: "Remarks", width: "240px", textAlign: "left", headerTextAlign: "center", other: [{}] },
    { field: "Quantity", headerText: "Quantity", width: "160px", textAlign: "right", headerTextAlign: "center", other: [{ format: "n2" }] },
    { field: "FBRQuantity", headerText: "Quantity", width: "160px", textAlign: "right", headerTextAlign: "center", other: [{ format: "n2" }] },
    { field: "TotalAmount", headerText: "Total Amount", width: "160px", textAlign: "right", headerTextAlign: "center", other: [{ format: "n2" }] }
  ];

  const getList = async () => {
    // let FromDate = await securityService.OpeningDate()
    let FromDate = '01-JAN-25'
    const data = { InvoiceType: props.InvoiceType || 'SS',
           Type:'List',
     MainInvoiceID:0,
     FromDate:moment(FromDate).format('DD-MMM-YY'),
     ToDate:moment().format('DD-MMM-YY'),
     BuyerNTNCNIC:'',
     hS_CODE:'',
     InvoiceDetailID:0,
    };
    return await invoiceService.getForList(data);
  };

  const listActionComplete = async (grid, args, getListService, selectedRow) => {
    if (args.requestType === 'save' || args.requestType === 'cancel') {
      getListService();
    }

    if (args.requestType === 'save') {
      if (args.action === 'add') {
        const data = {
          InvoiceType: args.data.InvoiceType || props.InvoiceType || 'SS',
          InvoiceID: args.data.InvoiceID,
          InvoiceDate: moment(args.data.InvoiceDate).format('DD-MMM-YY'),
          BuyerNTNCNIC: args.data.BuyerNTNCNIC,
          InvoiceReferenceNo: args.data.InvoiceReferenceNo || '-',
          DueDate: moment(args.data.DueDate).format('DD-MMM-YY'),
          Remarks: args.data.Remarks || '-',
          CompanyID:securityService.getCompanyIDLoggedInUserId(),
          details: details
        };

        const response = await invoiceService.addRecords(data);
        if (response) await getListService();
      }

      if (args.action === 'edit' && args.data.MainInvoiceID && details.length === 0) {
        await invoiceService.updateMainData({
          MainInvoiceID: args.data.MainInvoiceID,
          InvoiceDate: moment(args.data.InvoiceDate).format('DD-MMM-YY'),
          BuyerNTNCNIC: args.data.BuyerNTNCNIC,
          InvoiceReferenceNo: args.data.InvoiceReferenceNo || '-',
          DueDate: moment(args.data.DueDate).format('DD-MMM-YY'),
          Remarks: args.data.Remarks || '-'
        });
        await getListService();
      }

      if (args.action === 'edit' && details.length > 0 && args.data.MainInvoiceID) {
        // Insert NEW detail rows first
        await invoiceService.addRecords({
          MainInvoiceID: args.data.MainInvoiceID,
          details: details
        });

        // Update master
        await invoiceService.updateMainData({
          MainInvoiceID: args.data.MainInvoiceID,
          InvoiceDate: moment(args.data.InvoiceDate).format('DD-MMM-YY'),
          BuyerNTNCNIC: args.data.BuyerNTNCNIC,
          InvoiceReferenceNo: args.data.InvoiceReferenceNo || '-',
          DueDate: moment(args.data.DueDate).format('DD-MMM-YY'),
          Remarks: args.data.Remarks || '-'
        });

        await getListService();
      }
    }
  };

  // Security strings (keep same convention as your app)
  const ListSecurity = `Sale Invoice`;
  const AddSecurity = `Sale Invoice`;
  const EditSecurity = `Sale Invoice`;
  const DeleteSecurity = `Sale Invoice`;

  let menuItemsMap = {
    InvoicePreview: 'Preview C',
    InvoicePreviewD: 'Preview D',
    InvoicePreviewF: 'Preview F'
    
  };
  
  let isProcessing = false;
  const reportMenuItems = [
    { separator: true },
    { text: 'Preview C', id: 'InvoicePreview' },
    { separator: true },
    { text: 'Preview D', id: 'InvoicePreviewD' },
    { separator: true },
    { text: 'Preview F', id: 'InvoicePreviewF' },
   ];

    // { text: "Preview C",   tooltipText: "Invoice Preview",   id: "InvoicePreview",    },
        // { text: "Preview D", tooltipText: "Invoice Preview D", id: "InvoicePreviewD",
          //  prefixIcon: "e-icons e-print" 
          // },
        // { text: "Preview F", tooltipText: "Invoice Preview F", id: "InvoicePreviewF",
          //  prefixIcon: "e-icons e-print" 
          // },
  const toolbarOptions =props.InvoiceType == 'SS' ? ['Add', 'Edit', 'Delete', 'Update', 'Cancel',
  {
    text: "Reports",
    tooltipText: "Reports & Export",
    id: "ReportsMenu",
    prefixIcon: "e-icons e-print"
  },
       
     'PDFExport', 'ExcelExport', 'Search', 'ColumnChooser'] : 
     ['Add', 'Edit', 'Delete', 'Update', 'Cancel','PDFExport', 'ExcelExport', 'Search', 'ColumnChooser'];

  const allowTemplate = false;
  const allowGridSum = true;
  const gridSumColumns = ['InvoiceTotalAmount'];

  const listDelete = [{ TableName: ['InvoiceDetail', 'Invoice'], TableID: ['MainInvoiceID', 'MainInvoiceID'] }];
  const deleteType = 'Hard';

   //  ===== GENERATING QR CODE ======
        function generateQRCodeBlob(value) {
          return new Promise((resolve) => {
            const container = document.createElement('div');
            container.style.position = 'absolute';
            container.style.left = '-9999px';
            container.style.width = '96px';
            container.style.height = '96px';
            document.body.appendChild(container);
        
            const qrCode = new QRCodeGenerator({
              width: '96px',
              height: '96px',
              value: value,
              mode: 'Canvas',
              backgroundColor: 'transparent',
              version: 2,
              displayText: { visibility: false },
              margin: { left: 0, right: 0, top: 0, bottom: 0 }
            });
        
            qrCode.appendTo(container);
        
            setTimeout(() => {
              const canvas = container.querySelector('canvas');
              if (canvas) {
      
                const jpegCanvas = document.createElement('canvas');
                jpegCanvas.width = canvas.width;
                jpegCanvas.height = canvas.height;
                const ctx = jpegCanvas.getContext('2d');
        
                // Optional: white background for JPEG
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, jpegCanvas.width, jpegCanvas.height);
        
                ctx.drawImage(canvas, 0, 0);
        
                jpegCanvas.toBlob((blob) => {
                  container.remove();
                  resolve(blob);
                }, 'image/jpeg', 1.0); // Quality: 1.0
              } else {
                container.remove();
                resolve(null);
              }
            }, 150);
          });
        }


  // const toolbarClicking = async (grid, args) => {
  //   const itemId = args?.item?.id;
  //   if (itemId !== "InvoicePreview" && itemId !== "InvoicePreviewD" && itemId !== 'InvoicePreviewF')   return;

  //   const selected = grid?.getSelectedRecords ? grid.getSelectedRecords()[0] : null;
  //   if (!selected?.MainInvoiceID) {
  //     alert("Please select an invoice row first.");
  //     return;
  //   }
  //   console.log(selected);
  //   let FromDate = '01-JAN-25';
  //   const data = {
  //     InvoiceType: props.InvoiceType || 'SS',
  //     Type: 'Detail',
  //     MainInvoiceID: selected.MainInvoiceID || 0,
  //     FromDate: moment(FromDate).format('DD-MMM-YY'),
  //     ToDate: moment().format('DD-MMM-YY'),
  //     BuyerNTNCNIC: '',
  //     hS_CODE: '',
  //     InvoiceDetailID: 0
  //   };

  //   const detailRes  = await invoiceService.getInvoiceDetail(data);
  //   const detailRows = detailRes?.data?.recordset || detailRes?.data || [];
  //   const blob       = await generateQRCodeBlob(detailRows[0]?.FBRSaleInvoiceNo ?? '');
  //   if (!blob) return;

  //   const enrichedMain = {
  //     ...detailRows[0],
  //     ...selected,
  //     ChallanNo:        detailRows[0]?.ChallanNo        ?? '',
  //     FBRSaleInvoiceNo: detailRows[0]?.FBRSaleInvoiceNo ?? '',
  //   };

  //   if (itemId === "InvoicePreview") {
  //     await invoiceService.generateInvoiceReportPDF(enrichedMain, detailRows, blob);
  //   } else if (itemId == 'InvoicePreviewF'){

  //     await invoiceService.generateInvoiceReportPDFF(enrichedMain, detailRows, blob);
  //   } else {
  //     await invoiceService.generateInvoiceReportPDFD(enrichedMain, detailRows, blob);
  //   }
  // };


  
  const toolbarClicking = async (grid, args) => {
    const itemId = args?.item?.id;
  
    if (itemId === "ReportsMenu") {
      openReportsMenu({
        target: args.originalEvent.target,
        grid,
        items: reportMenuItems,
        onClick: async (id) => {
          await handleReportAction(id, grid);
        }
      });
      return;
    }
  };
  
  const handleReportAction = async (itemId, grid) => {
  
    if (isProcessing) return;
  
    const selected = grid?.getSelectedRecords ? grid.getSelectedRecords()[0] : null;
  
    if (!selected?.MainInvoiceID) {
      alert("Please select an invoice row first.");
      return;
    }
  
    try {
      isProcessing = true;
  
      // ✅ pass menuItemsMap
      setMenuLoading(itemId, true, menuItemsMap);
  
  
  
      let FromDate = '01-JAN-25';
  
      const data = {
        InvoiceType: props.InvoiceType || 'SS',
        Type: 'Detail',
        MainInvoiceID: selected.MainInvoiceID || 0,
        FromDate: moment(FromDate).format('DD-MMM-YY'),
        ToDate: moment().format('DD-MMM-YY'),
        BuyerNTNCNIC: '',
        hS_CODE: '',
        InvoiceDetailID: 0
      };
  
      const detailRes  = await invoiceService.getInvoiceDetail(data);
      const detailRows = detailRes?.data?.recordset || detailRes?.data || [];
  
      const blob = await generateQRCodeBlob(
        detailRows[0]?.FBRSaleInvoiceNo ?? ''
      );
  
      // ❗ IMPORTANT FIX: avoid stuck loading
      if (!blob) {
        console.warn("QR Blob not generated");
        return;
      }
  
      const enrichedMain = {
        ...detailRows[0],
        ...selected,
        ChallanNo:        detailRows[0]?.ChallanNo        ?? '',
        FBRSaleInvoiceNo: detailRows[0]?.FBRSaleInvoiceNo ?? '',
      };
  
      // ✅ actions
      console.log(itemId)
      if (itemId === "InvoicePreview") {
        await invoiceService.generateInvoiceReportPDF(enrichedMain, detailRows, blob);
      } 
      else if (itemId === "InvoicePreviewF") {
        await invoiceService.generateInvoiceReportPDFF(enrichedMain, detailRows, blob);
      } 
      else if (itemId === "InvoicePreviewD") {
        await invoiceService.generateInvoiceReportPDFD(enrichedMain, detailRows, blob);
      } 
     
  
    } catch (err) {
      console.error("Report Error:", err);
      alert("Error generating report");
    } finally {
  
      // ✅ ALWAYS reset state
      isProcessing = false;
  
     
  
      // ✅ restore text
      setMenuLoading(itemId, false, menuItemsMap);
    }
  };


  return (
    <DynamicInputList
      Id='Invoices'
      ListTitle={`${props?.Title || 'SALE INVOICE'}  -  List`}
      ColumnsList={columns}
      GridDataSource={[
        {
          DataSourceType: 'Function',
          DataSource: () => getList()
        }
      ]}
      DefaultSortedColumnName={'MainInvoiceID'}
      GridDialog={[
        {
          DialogType: 'Self',
          Dialog: (
            <InvoiceAdd
              getDetails={detailsUpdate}
              UserID={securityService.getLoggedInUserId()}
              Title={`${props?.Title || 'SALE INVOICE'}`}
              InvoiceType={props.InvoiceType || 'SS'}
              {...props}
            />
          )
        }
      ]}
      ListActionComplete={listActionComplete}
      ToolbarClicking={toolbarClicking}
      AllowTemplate={allowTemplate}
      ToolbarOption={toolbarOptions}
      ListSecurity={ListSecurity}
      AddSecurity={AddSecurity}
      EditSecurity={EditSecurity}
      DeleteSecurity={DeleteSecurity}
      ListDelete={listDelete}
      DeleteType={deleteType}
      GridSumColumns={gridSumColumns}
      AllowGridSum={allowGridSum}
      HeadTitle={`${props?.Title || 'SALE INVOICE'}  -  List`}
      IsDialog={props?.IsDialog ?? props?.isDialog ?? false}
      {...props}
    />
  );
};

export default InvoiceList;